// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  padding: 16px;
  max-width: 800px;
  margin: 0 auto;
}

.step-content {
  padding: 16px 8px;
}

.photo-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
}
.photo-upload .photo-preview {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  overflow: hidden;
  border: 2px dashed #ccc;
}
.photo-upload .photo-preview.has-image {
  border: none;
}
.photo-upload .photo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.photo-upload .photo-preview mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #999;
}
.photo-upload button {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.form-fields .full-width {
  width: 100%;
}
.form-fields mat-checkbox {
  margin: 8px 0;
}
.form-fields .contact-actions {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}
.form-fields .contact-actions button {
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 1.1rem;
}

.section-description {
  margin: 0 0 16px 0;
  color: #666;
  font-size: 0.9rem;
}
.section-description.accent {
  color: #3880ff;
}

.safety-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
.safety-options mat-checkbox {
  margin: 4px 0;
}
.safety-options mat-checkbox .option-content {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}
.safety-options mat-checkbox .option-content .option-title {
  font-weight: 500;
  color: #333;
}
.safety-options mat-checkbox .option-content .option-description {
  font-size: 0.8rem;
  color: #666;
  margin-top: 2px;
}

.step-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

@media (min-width: 600px) {
  .form-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .form-fields .full-width {
    grid-column: 1/span 2;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/features/profile/child-form/child-form.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;AACI;EACE,YAAA;AACN;AAEI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAAN;AAGI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAHJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;AAME;EACE,WAAA;AAJJ;AAOE;EACE,aAAA;AALJ;AAQE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANN;;AAWA;EACE,iBAAA;EACA,WAAA;EACA,iBAAA;AARF;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AARF;AAUE;EACE,cAAA;AARJ;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AATF;AAWE;EACE,aAAA;AATJ;AAWI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AATN;AAWM;EACE,gBAAA;EACA,WAAA;AATR;AAYM;EACE,iBAAA;EACA,WAAA;EACA,eAAA;AAVR;;AAgBA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AAbF;;AAgBA;EACE;IACE,aAAA;IACA,8BAAA;IACA,SAAA;EAbF;EAeE;IACE,qBAAA;EAbJ;AACF;AACA,g9IAAg9I","sourcesContent":[".form-container {\n  padding: 16px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.step-content {\n  padding: 16px 8px;\n}\n\n.photo-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 24px;\n  \n  .photo-preview {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    background-color: #f5f5f5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 16px;\n    overflow: hidden;\n    border: 2px dashed #ccc;\n    \n    &.has-image {\n      border: none;\n    }\n    \n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n    \n    mat-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n      color: #999;\n    }\n  }\n  \n  button {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n}\n\n.form-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  \n  .full-width {\n    width: 100%;\n  }\n  \n  mat-checkbox {\n    margin: 8px 0;\n  }\n  \n  .contact-actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 8px;\n    \n    button {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n  }\n}\n\n.section-title {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.section-description {\n  margin: 0 0 16px 0;\n  color: #666;\n  font-size: 0.9rem;\n  \n  &.accent {\n    color: #3880ff;\n  }\n}\n\n.safety-options {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n  \n  mat-checkbox {\n    margin: 4px 0;\n    \n    .option-content {\n      display: flex;\n      flex-direction: column;\n      margin-left: 8px;\n      \n      .option-title {\n        font-weight: 500;\n        color: #333;\n      }\n      \n      .option-description {\n        font-size: 0.8rem;\n        color: #666;\n        margin-top: 2px;\n      }\n    }\n  }\n}\n\n.step-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #eee;\n}\n\n@media (min-width: 600px) {\n  .form-fields {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    \n    .full-width {\n      grid-column: 1 / span 2;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
